// Validación completa del formulario de contacto

export const validateContactForm = (formData) => {
  const errors = {};

  // NOMBRE
  if (!formData.name || !formData.name.trim()) {
    errors.name = "El nombre es obligatorio";
  } else if (formData.name.trim().length < 3) {
    errors.name = "El nombre debe tener al menos 3 caracteres";
  } else if (formData.name.trim().length > 60) {
    errors.name = "El nombre es demasiado largo";
  } else if (!/^[a-zA-ZÀ-ÿ\s]+$/.test(formData.name)) {
    errors.name = "El nombre solo debe contener letras";
  }

  // EMAIL
  if (!formData.email || !formData.email.trim()) {
    errors.email = "El correo es obligatorio";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = "Ingresa un correo válido";
  }

  // TELÉFONO
  if (!formData.phone || !formData.phone.trim()) {
    errors.phone = "El teléfono es obligatorio";
  } else if (!/^[0-9]+$/.test(formData.phone)) {
    errors.phone = "El teléfono solo debe contener números";
  } else if (formData.phone.length < 7) {
    errors.phone = "El teléfono es demasiado corto";
  } else if (formData.phone.length > 15) {
    errors.phone = "El teléfono es demasiado largo";
  }

  // DIVISIÓN
  if (!formData.division) {
    errors.division = "Selecciona una división";
  }

  // SERVICIO 
  const needsService =
    formData.division && formData.division !== "otro";

  if (needsService && !formData.service) {
    errors.service = "Selecciona un servicio";
  }

  // EQUIPO (solo si aplica)
  if (
    formData.division === "ambiental" &&
    formData.service === "Alquiler de equipos" &&
    !formData.equipment
  ) {
    errors.equipment = "Selecciona el equipo que necesitas";
  }

  // MENSAJE
  if (!formData.message || !formData.message.trim()) {
    errors.message = "El mensaje es obligatorio";
  } else if (formData.message.trim().length < 10) {
    errors.message = "El mensaje debe tener al menos 10 caracteres";
  } else if (formData.message.trim().length > 1000) {
    errors.message = "El mensaje es demasiado largo";
  }

  return errors;
};

// VALIDACIÓN DE ARCHIVOS (OPCIONAL)
export const validateFiles = (files = []) => {
  if (!files.length) return null;

  const allowedTypes = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "image/jpeg",
    "image/png",
  ];

  const maxSize = 5 * 1024 * 1024; // 5MB

  for (const file of files) {
    if (!allowedTypes.includes(file.type)) {
      return `El archivo "${file.name}" no está permitido`;
    }

    if (file.size > maxSize) {
      return `El archivo "${file.name}" supera los 5MB`;
    }
  }

  return null;
};